@if (aberta) {
  <div class="gnf-overlay" (click)="onFechar()"></div>

  <aside class="gnf-panel">

    <div class="gnf-header">
      <span class="gnf-header-icon">
        <mat-icon class="material-symbols-outlined">inbox</mat-icon>
      </span>
      <div class="gnf-header-text">
        <div class="gnf-title">Gaveta de NFs</div>
        <div class="gnf-subtitle">Aguardando vínculo com pedido</div>
      </div>
      <button mat-icon-button type="button" class="gnf-close icon-mat-symbols-btn" (click)="onFechar()"
        matTooltip="Fechar" aria-label="Fechar">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>

    @if (!avisoOculto) {
      <div class="gnf-aviso">
        <mat-icon class="material-symbols-outlined">info</mat-icon>
        <div>
          A gaveta lista as notas de entrada sem pedido vinculado. Notas com <b>divergência</b> que impede o vínculo
          precisam ser resolvidas na Central antes do vínculo; a única exceção tratada aqui é a associação de itens,
          que pode ser feita direto pelo card. Para vincular a nota a um pedido, todos os itens precisam estar
          <b>associados</b> aos produtos do sistema.
        </div>
        <button type="button" class="gnf-aviso-fechar" (click)="ocultarAviso()"
          matTooltip="Ocultar mensagem" aria-label="Ocultar mensagem">
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      </div>
    }

    <div class="gnf-toolbar">
      <span class="gnf-pendentes">
        <span class="gnf-dot"></span>
        Pendentes
        <b>{{ totalRegistros }}</b>
      </span>
      <span class="gnf-toolbar-spacer"></span>
      @if (avisoOculto) {
        <button type="button" class="gnf-icon-btn" (click)="exibirAviso()" matTooltip="Mostrar aviso">
          <mat-icon class="material-symbols-outlined">info</mat-icon>
        </button>
      }
      <button type="button" class="gnf-icon-btn" (click)="recarregar()"
        [disabled]="carregando" matTooltip="Atualizar">
        <mat-icon class="material-symbols-outlined">refresh</mat-icon>
      </button>
      <button type="button" class="gnf-icon-btn"
        [class.gnf-icon-btn--ativo]="filtroAberto || temFiltro"
        (click)="alternarFiltro()" matTooltip="Filtrar por fornecedor">
        <mat-icon class="material-symbols-outlined">filter_list</mat-icon>
        @if (temFiltro) {
          <span class="gnf-filtro-dot"></span>
        }
      </button>
    </div>

    @if (filtroAberto) {
      <div class="gnf-filtro" [formGroup]="filtroModel">
        <app-select-pesquisavel
          label="Fornecedor"
          [control]="fornecedorControl"
          [idField]="'id'"
          [nameField]="'descricao'"
          [apiUrl]="urlFornecedor"
          [multiple]="true"
          [isOptional]="true"
          subscriptSizing="dynamic"
          hint="Selecione um fornecedor">
        </app-select-pesquisavel>

        <button mat-stroked-button type="button" class="btn-filter gnf-limpar" (click)="limparFiltro()">
          <mat-icon class="material-symbols-outlined">cleaning_services</mat-icon>
          Limpar Filtros
        </button>
      </div>
    }

    <div class="gnf-lista">

      @if (!substituindo) {
      @for (nota of notas; track nota.idNFeEntrada) {
        <article class="gnf-card">
          <div class="gnf-card-topo">
            <span class="gnf-card-numero">NF-e {{ numeroNota(nota) }}</span>
            <span class="gnf-card-emissao" [matTooltip]="rotuloDataCard(nota)">
              <mat-icon class="material-symbols-outlined">event</mat-icon>
              {{ (dataCard(nota) | date: 'dd/MM/yyyy') || '—' }}
            </span>
          </div>

          <div class="gnf-card-badges">
            <span class="status-badge" [ngClass]="classeBadgeStatus(nota.idStatusNFeEntrada)">
              <mat-icon class="material-symbols-outlined">{{ iconeStatus(nota.idStatusNFeEntrada) }}</mat-icon>
              {{ rotuloStatus(nota.idStatusNFeEntrada) }}
            </span>
            @if (nota.possuiDivergenciaBloqueante) {
              <span class="status-badge badge-vermelho"
                matTooltip="Divergência bloqueante na Central de NFs. Resolva na nota para confirmar o lançamento.">
                <mat-icon class="material-symbols-outlined">error</mat-icon>
                Divergência
              </span>
            }
          </div>

          @if (isFornecedorCarregando(nota)) {
            <span class="gnf-sk gnf-sk--fornecedor" aria-hidden="true"></span>
          } @else {
            <div class="gnf-card-fornecedor">{{ nomeFornecedor(nota) }}</div>
          }

          @if (cnpjFornecedor(nota); as cnpjEmitente) {
            <div class="gnf-card-cnpj">
              CNPJ <span class="gnf-card-cnpj-valor">{{ cnpjEmitente | cpfCnpj }}</span>
            </div>
          }

          <div class="gnf-card-valor">{{ nota.valorTotal || 0 | abnt: 'preco' : 2 }}</div>

          <div class="gnf-card-acoes">
            @if (nota.possuiDivergenciaBloqueiaVinculo) {
              <button mat-stroked-button type="button" class="btn-secondary gnf-card-botao"
                [disabled]="vinculandoId !== null" (click)="resolverDivergencia(nota)">
                <mat-icon class="material-symbols-outlined">error</mat-icon>
                Resolver divergências
              </button>
            } @else if (nota.possuiAssociacaoPendente) {
              <button mat-flat-button type="button" class="btn-primary gnf-card-botao"
                [disabled]="vinculandoId !== null" (click)="abrirAssociacaoItens(nota)">
                <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
                Associar itens
              </button>
            } @else {
              <button mat-flat-button type="button" class="btn-primary gnf-card-botao btn-spinner"
                [class.btn-loading]="vinculandoId === nota.idNFeEntrada"
                [disabled]="vinculandoId !== null" aria-label="Vincular ao pedido" (click)="vincularAoPedido(nota)">
                <mat-icon class="material-symbols-outlined">link</mat-icon>
                Vincular ao pedido
                @if (vinculandoId === nota.idNFeEntrada) { <mat-spinner diameter="20"></mat-spinner> }
              </button>
            }
          </div>
        </article>
      }
      }

      @if (carregando) {
        @for (slot of skeletonSlots; track slot) {
          <article class="gnf-card gnf-card--skeleton" aria-hidden="true">
            <div class="gnf-sk-topo">
              <span class="gnf-sk gnf-sk--numero"></span>
              <span class="gnf-sk gnf-sk--data"></span>
            </div>
            <span class="gnf-sk gnf-sk--badge"></span>
            <span class="gnf-sk gnf-sk--fornecedor"></span>
            <span class="gnf-sk gnf-sk--cnpj"></span>
            <span class="gnf-sk gnf-sk--valor"></span>
            <span class="gnf-sk gnf-sk--botao"></span>
          </article>
        }
      }

      @if (vazia) {
        <div class="gnf-vazio">
          <mat-icon class="material-symbols-outlined">inbox</mat-icon>
          @if (vaziaSemCadastro) {
            <div class="gnf-vazio-titulo">Nenhuma NF pendente</div>
            <div class="gnf-vazio-texto">Todas as notas capturadas já foram vinculadas.</div>
          } @else {
            <div class="gnf-vazio-titulo">Nenhuma NF encontrada</div>
            <div class="gnf-vazio-texto">Nenhuma nota pendente para o fornecedor selecionado.</div>
          }
        </div>
      }

      @if (!ultimaPagina && !carregando) {
        <button mat-button type="button" class="btn-ver-mais gnf-ver-mais" (click)="carregarMais()">
          <span class="material-symbols-outlined">expand_more</span> Ver Mais
        </button>
      }

    </div>

    <div class="gnf-footer">
      <!-- Nova aba: a gaveta e o quadro continuam abertos aqui. -->
      <a routerLink="/suprimentos/nota-fiscal-entrada" target="_blank" rel="noopener" class="gnf-footer-link">
        <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
        Ver central de notas
      </a>
    </div>

  </aside>
}
